import {OptionItem} from "./option-item";

export function SearchResultsLi(value, label, selected, onClick) {
    this.liElement = document.createElement('li');
    this.liElement.setAttribute('data-value', value);
    this.liElement.innerText = label;
    this.isSelected = selected;
    this.item = new OptionItem(value, label);

    const self = this;

    this.liElement.addEventListener('click', function (evt) {
        if (!self.isSelected) {
            onClick(self.item);
        }
    });

    this.liElement.addEventListener('mouseover', function (evt) {
        const children = self.liElement.parentElement.children;
        for (let i = 0; i < children.length; i++) {
            const child = children[i];
            if (child.className.indexOf('selected') > 0) {
                child.className = 'selected';
            } else {
                child.className = '';
            }
        }

        self.liElement.className += ' hover';
    });

    this.setSelected = function (selected) {
        this.isSelected = selected;
        this.liElement.setAttribute('data-selected', this.isSelected);
    };

    this.elem = function () {
        return this.liElement;
    };

    this.setSelected(selected);
}